
    <label class="radio" *ngFor="let elem of formVariable.formVariableValues ; let elemIdx = index">
      <input type="radio"> {{elem.validValueDesc}}
    </label>